<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">门票收入统计</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="时间" prop="timeRange">
              <el-date-picker
                v-model="queryParams.timeRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                :clearable="false">
              </el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="totalCost">门票总收入（元）：{{totalCost}}</div>
        <div class="ecahrts-wrap">
          <div class="ecahrts-left">
              <LineEchart2Ticket
                title="门票收入趋势图"
                xAxisName=""
                yAxisName=""
                :chartData="compareData"
                :legendData="legendData"
                className="echarts-01"
              ></LineEchart2Ticket>
          </div>
          <div class="echart-right">
               <PieEchartsTicket
                title="门票类型分析"
                xAxisName=""
                yAxisName=""
                :chartData="typeData"
                className="echarts-02"
              ></PieEchartsTicket>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getTypeDataByTimes, getTrendByTimes, getTravelAgencyDataByTimes } from "@/api/src/bigData";

import ZJApp from '../../../../app';
const utils = ZJApp.ZJUtils;

import moment from 'moment';
export default {
  name: "Ticket",
  controller: "UI",
  action: "Ticket",
  components: {
  },
  data() {
    return {
      // 遮罩层
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      queryParams:{
        timeRange:null,
      },
      compareData:{
        days:[],
        data:[],
        dataLast:[],
      },
      legendData:[],
      typeData:[],
      totalCost:0
    };
  },
  created: function() {
    this.$nextTick(()=>{
      this.onCancel()
    });
  },
  methods: {
   // 点击清理按钮
    onCancel() {
      this.queryParams.timeRange = [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]
      this.onSearch();
    },
    async onSearch(){
      this.loading = true
      this.init()
      let { queryParams:{timeRange:[startTime, endTime]} } = this, that = this;
      var params = this.getAreaTimeSearchParams(this.config.area.type, this.config.area.code, startTime, endTime);

      let year = this.getTimeRangLegend(beforeStartTime, beforeEndTime)
      let year2 = this.getTimeRangLegend(startTime, endTime)
      that.legendData =[year,year2]
      let beforeStartTime = moment(startTime).subtract(1, 'year').format('YYYY-MM-DD');
      let beforeEndTime = moment(endTime).subtract(1, 'year').format('YYYY-MM-DD');
      var params2 = this.getAreaTimeSearchParams(this.config.area.type, this.config.area.code, startTime, endTime);
      this.init()
      utils.waitAll([
        getTypeDataByTimes(params),
        getTrendByTimes("staTicketSell", params),
        getTrendByTimes("staTicketSell", params2),
      ])
      .then(res => {
        that.loading = false;

        that.totalCost = res[0].data.totalCost
        let typeData = []
        res[0].data.list&&res[0].data.list.forEach(item =>{
          console.log(item)
          if(item.children.length){
            item.children.forEach(child =>{
              typeData.push({
                name:child.name,
                value:child.cost
              })
            })
          }
        })
        that.typeData = typeData
        that.$set(that.compareData,'days',this.resetData(res[1].data,'dataTime', params.timeType))
        that.$set(that.compareData,'dataLast',this.resetData(res[1].data,'cost'))
        that.$set(that.compareData,'data',this.resetData(res[2].data,'cost'))

      }).catch((res =>{
        this.loading = false;
      }))
    },
    init(){
      this.compareData={
        days:[],
        data:[],
        dataLast:[],
      }
      this.legendData = []
      this.provinceTop10 = {
        days:[],
        data:[],
      }
      this.cityTop10 = {
        days:[],
        data:[],
      }
      this.ageData = {
        days:[],
        data:[],
      }
      this.sexData = [
        {name:'男',value:0},
        {name:'女',value:0}
      ]
      this.proveiceData = []
    },
    resetData(data,key,type){
      let arr = []
      data.forEach(item => {
        let value = item[key]
        if(type){
          value = this.getTimeByType(type, value)
        }
        arr.push(value)
      })
      return arr
    }
  },
};
</script>
<style scoped lang="scss">
.totalCost{
  font-size: 2.0rem;
  margin-bottom: 3rem;
}
.ecahrts-wrap {
  position: relative;
  width: 100%;
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom:2.8rem;
}
.ecahrts-left{
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  div{
    width: 100%;
    height: 100%;
  }
}
.echart-right {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  div{
    width: 100%;
    height: 100%;
  }
}
</style>
